import {
  AddToPhotos,
  Delete,
  DeleteSweep,
  Info,
  MenuOpen,
} from "@mui/icons-material";
import { IconButton, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

export default function TableDropwdownActions({
  handleEditData,
  handleDetailData,
  deleteClassItem,
  deleteItem,
  activeClassItem,
  styles,
  row,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  const role = useSelector((state) => state.auth.dataToken.roleId.roleName);
  const roleArray = [
    "super-admin",
    "admin", 
    "supervisor"
  ]
  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={() => {
          setAnchorEl(event.target);
          setOpen(true);
        }}
      >
        <MenuOpen />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <MenuItem onClick={() => handleDetailData()}>
          <Info className={styles.actionButtonEdit} fontSize="small" />
          Detail
        </MenuItem>

        {(roleArray.indexOf(role) > -1) ? (
            <MenuItem onClick={() => handleEditData()}>
              <EditIcon className={styles.actionButtonEdit} fontSize="small" />
              Edit
            </MenuItem>
          ) : ""}

        {role === "super-admin" && (
          <MenuItem onClick={() => deleteItem()}>
            <DeleteSweep
              className={styles.actionButtonDelete}
              fontSize="small"
            />
            Delete
          </MenuItem>
        )}

        {role === "super-admin" && (
          <MenuItem onClick={() => deleteClassItem()}>
            <Delete className={styles.actionButtonDelete} fontSize="small" />
            Delete Permanent
          </MenuItem>
        )}

        {!row.isActive && (
          <MenuItem onClick={() => activeClassItem()}>
            <AddToPhotos className={styles.actionButtonEdit} fontSize="small" />
            Aktifkan
          </MenuItem>
        )}
      </Menu>
    </>
  );
}

TableDropwdownActions.propTypes = {
  handleEditData: PropTypes.func.isRequired,
  handleDetailData: PropTypes.func.isRequired,
  deleteClassItem: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  activeClassItem: PropTypes.func.isRequired,
  styles: PropTypes.object.isRequired,
  row: PropTypes.object.isRequired,
};
